import React from 'react'
// components
import ObjectUpdate from 'components/PageComponents/Settings/ObjectsAndProperties/Edit'
// context
import ObjectsAPI from 'containers/ObjectsAndProperties/Edit/layers/API'

const ObjectUpdateContainer = () => (
  <ObjectsAPI>
    <ObjectUpdate />
  </ObjectsAPI>
)

export default ObjectUpdateContainer
